export default __webpack_public_path__ + "static/media/quiz-q19.aad32de4.png";